// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"539":"264783fc","781":"a4e5f74b","906":"36245974"}[chunkId] + ".chunk.js";
};